import { render } from "./KindName.vue?vue&type=template&id=175f731d&scoped=true"
import script from "./KindName.vue?vue&type=script&lang=js"
export * from "./KindName.vue?vue&type=script&lang=js"

import "./KindName.vue?vue&type=style&index=0&id=175f731d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175f731d"]])

export default __exports__